import React from 'react'
import {
  CardImgOverlay as ReactstrapCardImgOverlay,
  CardImgOverlayProps,
} from 'reactstrap'

export const CardImgOverlay: React.FC<CardImgOverlayProps> = props => {
  return <ReactstrapCardImgOverlay {...props} />
}
